/**
 * Emit hosts for the `referral` analytics group — 3 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';

export function trackReferralLinkCopied() {
  trackLegacyEvent({
    name: SegmentObjectName.Referral,
    props: {
      action: SegmentActionName.ReferralLinkCopied,
    },
  });

  // V2 — referral_shared
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ReferralShared,
    props: {},
  });
}

// referral
export function trackReferralLinkCreated() {
  trackLegacyEvent({
    name: SegmentObjectName.Referral,
    props: {
      action: SegmentActionName.ReferralLinkCreated,
    },
  });

  // V2 — referral_created
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ReferralCreated,
    props: {},
  });
}

export function trackReferralModalOpened() {
  trackLegacyEvent({
    name: SegmentObjectName.Referral,
    props: {
      action: SegmentActionName.ReferralModalOpened,
    },
  });

  // V2 — referral_viewed
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ReferralViewed,
    props: {},
  });
}
